import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../util/theme';

const HeaderButton = styled.button`
  background-color: ${getColor('primaryBlue')};

  color: ${getColor('white')};
  font-size: 1rem;
  font-weight: ${getFontWeight('medium')};

  padding: 5px 10px;
  margin: 0 0 10px 0;

  border: 1px solid ${getColor('white')};

  cursor: pointer;

  appearance: none;

  @media (min-width: ${getBreakpoint('sm')}) {
    font-size: 1.2rem;

    margin: 0 15px 0 0;
    padding: 10px 15px;
  }

  @media (min-width: ${getBreakpoint('md')}) {
    font-size: 1.6rem;

    margin: 0 30px 0 0;
  }

  &:hover {
    background-color: ${getColor('accentGreen')};

    color: ${getColor('primaryBlue')};
  }
`;

export default HeaderButton;
